import { render } from "./ReattachRequisitePopup.vue?vue&type=template&id=764f5842&ts=true"
import script from "./ReattachRequisitePopup.vue?vue&type=script&lang=ts"
export * from "./ReattachRequisitePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__